import { dashboardEventTypes } from "./dashboard/analyticDashboardEvents";

export default {
  ...dashboardEventTypes,
};
